var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"general-settings-page"},[_c('transition',{attrs:{"name":"fade-up"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingState.page),expression:"!loadingState.page"}],ref:"legacy"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }